import type {
  VisualPromptAnswers,
  VisualPromptStep,
  VisualPromptStepVisibleWhen,
} from '@/types/visualPrompts/visualPrompt.types';

const matchesVisibleWhen = (
  condition: VisualPromptStepVisibleWhen,
  answers: VisualPromptAnswers,
): boolean => {
  const value = answers[condition.field];
  if (value === undefined) {
    return false;
  }
  if (condition.equals !== undefined) {
    return String(value) === condition.equals;
  }
  if (condition.includes !== undefined) {
    if (Array.isArray(value)) {
      return value.includes(condition.includes);
    }
    return String(value) === condition.includes;
  }
  return true;
};

export const isStepVisible = (
  step: VisualPromptStep,
  answers: VisualPromptAnswers,
): boolean => {
  if (!step.visibleWhen) {
    return true;
  }
  return matchesVisibleWhen(step.visibleWhen, answers);
};

export const getVisibleSteps = (
  steps: VisualPromptStep[],
  answers: VisualPromptAnswers,
): VisualPromptStep[] => steps.filter((step) => isStepVisible(step, answers));
